import { render } from "./PopupInfoDeleteChat.vue?vue&type=template&id=fbae6a1a"
import script from "./PopupInfoDeleteChat.vue?vue&type=script&lang=js"
export * from "./PopupInfoDeleteChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__